export default __webpack_public_path__ + "static/media/IMG_2444-hydro-being-built-1-1point-5-768x511.e94423c7.jpg";